module.exports = __webpack_public_path__ + "img/yonghutouxiang.4e8af634.png";